export enum StatusQueries {
  StatusTable = 'statusTable',
}
